import { Avatar } from "@whoosh/design-system/src/components/display/Avatar";
import { Text, HStack } from "@whoosh/design-system/src/components/primitive";

import { CustomColor } from "./__generated__/EventDetailHosts.graphql";

type EventDetailHostItemProps = {
  profileImageId?: string;
  fullName: string;
  firstName: string;
  lastName: string;
  color: CustomColor;
};

export const EventDetailHostItem = ({
  profileImageId,
  fullName,
  firstName,
  lastName,
  color,
}: EventDetailHostItemProps) => {
  return (
    <HStack gap={2} alignItems="center" mt={4}>
      <Avatar
        profileImagePublicId={profileImageId}
        firstName={firstName}
        lastName={lastName}
        size="sm"
        type={color}
      />
      <Text maxFontSizeMultiplier={2} variant="mainBaseMedium" ml={2}>
        {fullName}
      </Text>
    </HStack>
  );
};
